import React from 'react';
import Web3 from 'web3';
import { withRouter } from 'react-router-dom';

import './Header.css';

class Header extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isMetamaskConnected: false,
      isAccountdetailOpened: false,
      userAccount: "",
    }
  }

  isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  checkAccountChange = () => {
    /*
    // 계정이 바뀌었는지 확인
    let currentAccount = await web3.eth.getAccounts().then(function(array) { return array[0] });
    // 현재 유저가 들고있는 계정(currentAccount)가 브라우저가 인식하는 계정(userAccount)와 다르다면
    if (currentAccount !== userAccount) {
        // 계정을 업데이트 해준다
        userAccount = currentAccount;
        // 새 계정에 대한 UI로 업데이트하기 위한 함수 호출 및 메시지 알림
        alert('Your account is ' + userAccount);
    }
    */
  }

  connectMetamask = () => {
    let web3 = new Web3(Web3.givenProvider);

    web3.eth.requestAccounts()
    .then((result) => {
      //console.log(result);
      this.setState({
        isMetamaskConnected: true,
        userAccount: result[0]
      })
    })
    .catch((err) => {
      this.setState({
        isMetamaskConnected: false,
        isAccountdetailOpened: false,
        userAccount: ""
      })
    })
  }

  trimAddress = (addr) => {
    return String(addr).substring(0,10);
  }

  renderMetamask = () => {
    if(this.state.isMetamaskConnected) { 
      return(
        <button className="APIS-swap-header-button-1-white" onClick={()=>{this.toggleAccountDetail()}}>
          Connected : <span className="APIS-swap-header-button-thin">{this.trimAddress(this.state.userAccount)}...</span>
        </button>
      )
    } else {
      return(
        <button className="APIS-swap-header-button-1" onClick={()=>{this.connectMetamask()}}>
          Connect Metamask
        </button>
      )
    }
  }

  toggleAccountDetail = () => {
    this.setState({
      isAccountdetailOpened: !this.state.isAccountdetailOpened
    })
  }

  renderAccountdetail = () => {
    if(this.state.isAccountdetailOpened) {
      return null;
    } else {
      return null;
    }
  }

  componentDidMount() {
    this.connectMetamask();
  }

  render() {
    if(this.isMobile()) {
      return (
        <div className="APIS-swap-header">
          <div className="APIS-swap-header-content">
            <img className="APIS-swap-header-logo" src={require("../../Asset/APIS_swap_logo.png")} onClick={()=>{window.location.href = "https://swap.apis.eco"}}/>
          </div>
        </div>
      )
    } else {
      return (
        <div className="APIS-swap-header">
          <div className="APIS-swap-header-content">
            <img className="APIS-swap-header-logo" src={require("../../Asset/APIS_swap_logo.png")} onClick={()=>{window.location.href = "https://swap.apis.eco"}}/>
  
            <div className="APIS-swap-header-buttondiv">
              {this.renderMetamask()}
              <button className="APIS-swap-header-button-2" onClick={()=>{window.location.href = "https://apis.mn"}}>
                Platform
              </button>
            </div>
            <div className="APIS-swap-header-toggle">
              {this.renderAccountdetail()}
            </div>
          </div>
        </div>
      )
    }
  }
}

export default withRouter(Header);